import { render, staticRenderFns } from "./_base-input.vue?vue&type=template&id=b3596914&scoped=true"
import script from "./_base-input.vue?vue&type=script&lang=js"
export * from "./_base-input.vue?vue&type=script&lang=js"
import style0 from "./_base-input.vue?vue&type=style&index=0&id=b3596914&prod&lang=scss&module=true&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "b3596914",
  null
  
)

export default component.exports